import Axios from "axios";

const qs = require("qs");
export const env = process.env.NODE_ENV;
console.log();
Axios.defaults.baseURL = env === "development" ? "/api/api" : "/api";

const token = sessionStorage.getItem("rsc-token");
if (token) {
  Axios.defaults.headers.token = token;
}

// Axios.defaults.baseURL = env === '/api'
console.log(Axios.defaults.baseURL);
Axios.interceptors.response.use(response => {
  if (response.status === 200 || response.status === 304) {
    return response.data;
  } else if (response.status === 400) {
    return response.statusText;
  } else {
    return false;
  }
});
export const checkUrl = Axios.defaults.baseURL + "/summit/checkImageVerify";
// api/summit/createImageVerify
export const voteUrl = Axios.defaults.baseURL + "/summit/vote";
export const sendImageVerifyUrl =
  Axios.defaults.baseURL + "/summit/sendImageVerify";
export const voteLoginUrl = Axios.defaults.baseURL + "/summit/voteLogin";

// 生产环境域名
const PROD_DOMAIN = "https://vote.roadshowchina.cn";
const UAT_DOMAIN = "https://vote.roadshowchina.cn";

export function getIsProdDomain() {
  const protocol = location.protocol;
  const host = location.host;
  const curDomain = `${protocol}//${host}`;
  return curDomain === PROD_DOMAIN;

  // return true
}

function param(data) {
  let url = "";
  for (let key in data) {
    let item = data[key] !== undefined ? data[key] : "";
    url += `&${key}=${encodeURIComponent(item)}`;
  }
  return url ? url : "";
}
// jsonp请求
Axios.jsonp = (url, data, fnName) => {
  if (data) {
    url += (url.indexOf("?") < 0 ? "?" : "&") + param(data);
  }
  if (!url) {
    console.error("Axios.JSONP 至少需要一个url参数!");
    return;
  }
  return new Promise((resolve, reject) => {
    if (fnName) {
      window[fnName] = result => {
        resolve(result);
      };
    } else {
      window.success_mainCallback = result => {
        resolve(result);
      };
    }

    var JSONP = document.createElement("script");
    JSONP.type = "text/javascript";
    let timestamp = "202112271707";
    if (fnName) {
      JSONP.src =
        url.indexOf("?") > -1
          ? `${url}&jsonpCallback=${fnName}&v=${timestamp}`
          : `${url}?jsonpCallback=${fnName}&v=${timestamp}`;
    } else {
      JSONP.src =
        url.indexOf("?") > -1
          ? `${url}&jsonpCallback=success_mainCallback&v=${timestamp}`
          : `${url}?jsonpCallback=success_mainCallback&v=${timestamp}`;
    }
    document.getElementsByTagName("head")[0].appendChild(JSONP);
    setTimeout(() => {
      document.getElementsByTagName("head")[0].removeChild(JSONP);
    }, 500);
  });
};

// -------------2020/11/02----------------
export const getMeentApi = async url => {
  try {
    const res = await Axios.jsonp(url, "", "jsonpReturn");
    return res;
  } catch (err) {
    console.log(err);
  }
};

// -------------2020/11/02----------------
export const getFootImgApi = async data => {
  try {
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/vote-main.json?v=202112011030",
      { params: data }
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};
export const getOrgsApi = async data => {
  try {
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/orgs.json?v=202112061528",
      { params: data },
      "success_orgCallback"
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

// 获取热度榜
export const getRankApi = async data => {
  try {
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/rank.json",
      { params: data },
      "success_rankCallback"
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getPopularity = async data => {
  //奖项获奖列表
  try {
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/json/winPopularity.json?v=555",
      {},
      "success_jsonpCallback"
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};
export const getvoteItemDetail = async data => {
  //列表
  try {
    console.log(data);
    // const res = await Axios.get('/summit/getWinList', )
    // const res = await Axios.jsonp('https://vote-dev.roadshowchina.cn/api/summit/winPopularity?v=555',{},'success_jsonpCallback')
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/json/win_" +
        data.itemId +
        ".json",
      "",
      "success_jsonpCallback" + data.itemId
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getNomineeInfo = async data => {
  // 详情
  console.log(data);
  try {
    // const res = await Axios.get('/summit/nomineeInfo', {params: data})
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/json/obj_" +
        data.objId +
        ".json",
      "",
      "success_jsonpCallback"
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

// export const getPopularity = async (data) => { // 男神女神
//   try {
//     // const res = await Axios.get('/summit/winPopularity', {params: data})
//     // const res = await Axios.jsonp('https://vote-new.roadshowchina.cn/api/summit/winPopularity', data,'success_jsonpCallback')
//      const res = await Axios.jsonp('https://image.roadshowchina.cn/Uploads/Activity/vote/2020/json/winPopularity.json', '','success_jsonpCallback')
//     return res
//   } catch (err) {
//     console.log(err)
//   }
// }

export const checkVoteLogin = async data => {
  // 登录
  try {
    const token = sessionStorage.getItem("rsc-token");
    if (token) {
      Axios.defaults.headers.token = token;
    }
    const res = await Axios.get("/summit/checkVoteLogin", { params: data });
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const goToVote = async data => {
  // 投票
  try {
    const res = await Axios.post("/summit/vote", qs.stringify(data));
    return res;
  } catch (err) {
    console.log(err);
  }
};
export const getVoteItemDetailApi = async data => {
  // 奖项详细信息
  try {
    const res = await Axios.get("/summit/voteItemDetail", { params: data });
    return res;
  } catch (err) {
    console.log(err);
  }
};
export const getVerification = async data => {
  // 投票验证token
  try {
    const res = await Axios.get("/summit/verification", { params: data });
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getirVideoApi = async data => {
  //活动视频列表
  try {
    console.log(data);
    // const res = await Axios.get('/summit/voteItemDetail', {params: data})
    // const res = await Axios.jsonp('https://image.roadshowchina.cn/Uploads/Activity/vote/2021/irVideo.json?v=5555', data,'irVideo')
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/irVideo.json?v=202112221717",
      data,
      "irVideo"
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getJury = async data => {
  try {
    console.log(data);
    // const res = await Axios.get('/summit/voteItemDetail', {params: data})
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2020/jury.json",
      data,
      "juryCallback"
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getNomineeVoters = async data => {
  // 参投的投票者列表
  console.log(data);
  try {
    const res = await Axios.get("/summit/nomineeVoters", { params: data });
    // const res = await Axios.jsonp('https://image.roadshowchina.cn/Uploads/Activity/vote/2021/json/obj_'+data.objId+'.json', '','success_jsonpCallback')
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getNomineeInfoApi = async data => {
  // 参投者信息
  try {
    const res = await Axios.get("/summit/nomineeInfo", { params: data });
    return res;
  } catch (err) {
    console.log(err);
  }
  // const url = `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/json/obj_${data.objId}.json`;
  // return Axios.jsonp(
  //   `${url}?v=${sixthTimestamp}`,
  //   data,
  //   `success_jsonpCallback`
  // );
};

export const getContact = async data => {
  try {
    console.log(data);
    const res = await Axios.jsonp(
      "https://image.roadshowchina.cn/Uploads/Activity/vote/2021/contact.json",
      data,
      "contactCallback"
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

// ------------- 2022（第六届峰会） ----------------
// const sixthTimestamp = Math.round(Date.now() / 1000 / 60)
const sixthTimestamp = Date.now();
// ========= 峰会专题 =========
// 嘉宾、主办方
export const getSixthActivityGuestAndOrganizer = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/vote-main.json?v=${sixthTimestamp}`,
    data,
    "success_mainCallback"
  );
};

// 拟邀名单
export const getSixthActivityInviteOrg = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/orgs.json?v=${sixthTimestamp}`,
    data,
    "success_orgCallback"
  );
};

// 联系我们
export const getSixthActivityContactUs = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/contact.json?v=${sixthTimestamp}`,
    data,
    "contactCallback"
  );
};

// 视频
export const getSixthActivityIrVideo = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/irVideo.json?v=${sixthTimestamp}`,
    data,
    "irVideo"
  );
};

// 大会议程
export const getSixthActivitySchedule = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/summit/agenda.json?v=${sixthTimestamp}`,
    data,
    "agendaCallback"
  );
};

// 大会介绍
export const getSixthActivitySummitIntro = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/summit/info.json?v=${sixthTimestamp}`,
    data,
    "summitIntro"
  );
};

// 右侧边栏（PC）
export const getSixthActivityRightSidebar = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/summit/link.json?v=${sixthTimestamp}`,
    data,
    "activityRightSidebar"
  );
};

// 会场导航
export const getSixthActivityVenueMap = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/summit/meetingplace.json?v=${sixthTimestamp}`,
    data,
    "venueMapCallback"
  );
};

// 获取主页面奖项
export const getSixthPopularity = data => {
  // TODO: 替换为第六届 JSONP
  return Axios.get("/summit/popularity", { params: data });
};

// 获取列表页面奖项信息
export const getSixthVoteItemDetail = data => {
  // TODO: 替换为第六届 JSONP
  return Axios.get("/summit/voteItemDetail", { params: data });
};

// 获取参投者信息
export const getSixthNomineeInfo = data => {
  // TODO: 替换为第六届 JSONP
  // return Axios.get("/summit/nomineeInfo", { params: data });

  // https://image.roadshowchina.cn/Uploads/Activity/vote/2022/json/obj_5451.json
  const url = `https://image.roadshowchina.cn/Uploads/Activity/vote/2023/json/obj_${data.objId}.json`;
  return Axios.jsonp(
    `${url}?v=${sixthTimestamp}`,
    data,
    `success_jsonpCallback`
  );
};

export const getSixthVoteAward = data => {
  const url = `https://image${
    getIsProdDomain() ? "" : "-new"
  }.roadshowchina.cn/Uploads/Activity/vote/2022/vote-award.json`;

  return Axios.jsonp(`${url}?v=${sixthTimestamp}`, data, "voteAward");
};

// 获取主页面获奖信息
export const getSixthWinPopularity = data => {
  // TODO: 替换为第六届 JSONP
  // https://image.roadshowchina.cn/Uploads/Activity/vote/2022/json/winPopularity.json
  // return Axios.get("/summit/winPopularity", { params: data });
  const url = `https://image${
    getIsProdDomain() ? "" : ""
  }.roadshowchina.cn/Uploads/Activity/vote/2022/json/winPopularity.json`;

  return Axios.jsonp(
    `${url}?v=${sixthTimestamp}`,
    data,
    "success_jsonpCallback"
  );
};

// 获取列表页面获奖信息
export const getSixthWinList = data => {
  // TODO: 替换为第六届 JSONP
  // return Axios.get("/summit/getWinList", { params: data });
  const url = `https://image.roadshowchina.cn/Uploads/Activity/vote/2022/json/win_${data.itemId}.json`;
  return Axios.jsonp(
    `${url}?v=${sixthTimestamp}`,
    data,
    `success_jsonpCallback${data.itemId}`
  );
};



// ------------- 2022（第六届峰会） ----------------
// const sixthTimestamp = Math.round(Date.now() / 1000 / 60)
// ========= 峰会专题 =========
// 嘉宾、主办方
export const getSeventhActivityGuestAndOrganizer = data => {
  return Axios.jsonp(
    `https://image${
      getIsProdDomain() ? "" : "-new"
    }.roadshowchina.cn/Uploads/Activity/vote/2023/vote-main.json?v=${sixthTimestamp}`,
    data,
    "success_mainCallback"
  );
};

// 联系我们
export const getSeventhActivityContactUs = data => {
  return Axios.jsonp(
    `https://image.roadshowchina.cn/Uploads/Activity/vote/2023/contact.json?v=${sixthTimestamp}`,
    data,
    "contactCallback"
  );
};

export const getSeventhVoteAward = data => {
  const url = `https://image${
    getIsProdDomain() ? "" : "-new"
  }.roadshowchina.cn/Uploads/Activity/vote/2023/vote-award.json`;

  return Axios.jsonp(`${url}?v=1`, data, "voteAward");
};

// 大会议程
export const getSeventhActivitySchedule = data => {
  return Axios.jsonp(
    `https://image${
      getIsProdDomain() ? "" : "-new"
    }.roadshowchina.cn/Uploads/Activity/vote/2023/summit/agenda.json?v=${sixthTimestamp}`,
    data,
    "agendaCallback"
  );
};

// 右侧边栏（PC）
export const getSeventhActivityRightSidebar = data => {
  return Axios.jsonp(
    `https://image${
      getIsProdDomain() ? "" : "-new"
    }.roadshowchina.cn/Uploads/Activity/vote/2023/summit/link.json?v=${sixthTimestamp}`,
    data,
    "activityRightSidebar"
  );
};

// 拟邀名单
export const getSeventhActivityInviteOrg = data => {
  return Axios.jsonp(
    `https://image${
      getIsProdDomain() ? "" : "-new"
    }.roadshowchina.cn/Uploads/Activity/vote/2023/orgs.json?v=${sixthTimestamp}`,
    data,
    "success_orgCallback"
  );
};

// 大会介绍
export const getSeventhActivitySummitIntro = data => {
  return Axios.jsonp(
    `https://image${
      getIsProdDomain() ? "" : "-new"
    }.roadshowchina.cn/Uploads/Activity/vote/2023/summit/info.json?v=${sixthTimestamp}`,
    data,
    "summitIntro"
  );
};

// 视频
export const getSeventhActivityIrVideo = data => {
  return Axios.jsonp(
    `https://image${
      getIsProdDomain() ? "" : "-new"
    }.roadshowchina.cn/Uploads/Activity/vote/2023/summit/irVideo.json?v=${sixthTimestamp}`,
    data,
    "irVideo"
  );
};

// 会场导航
export const getSeventhActivityVenueMap = data => {
  return Axios.jsonp(
    `https://image${
      getIsProdDomain() ? "" : "-new"
    }.roadshowchina.cn/Uploads/Activity/vote/2023/summit/meetingplace.json?v=${sixthTimestamp}`,
    data,
    "venueMapCallback"
  );
};

// 获奖榜单
export const getSeventhWinPopularity = data => {
  const url = `https://image.roadshowchina.cn/Uploads/Activity/vote/2023/json/winPopularity.json`;

  return Axios.jsonp(
    `${url}?v=${sixthTimestamp}`,
    data,
    "success_jsonpCallback"
  );
};

//奖项获奖列表
export const getSeventhWinList = async data => {
  const url = `https://image.roadshowchina.cn/Uploads/Activity/vote/2023/json/win_${data.itemId}.json`;
  return Axios.jsonp(
    `${url}?v=${sixthTimestamp}`,
    data,
    `success_jsonpCallback${data.itemId}`
  );
};


// WEBPACK FOOTER //
// ./src/api/index.js